// Tab "Log": wie wijzigde wat, meest recent bovenaan. De server vult dit zelf.
import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { meldFout } from '../../../utils/apiFout';
import { lijstLog, INKT, STIL } from '../breakdownApi';
import { Kaart, Leeg, Rij } from '../onderdelen';

function geleden(iso) {
  const ms = Date.now() - new Date(String(iso).endsWith('Z') ? iso : `${iso}Z`).getTime();
  const min = Math.floor(ms / 60000);
  if (min < 1) return 'zojuist';
  if (min < 60) return `${min} min geleden`;
  const uur = Math.floor(min / 60);
  if (uur < 24) return `${uur} uur geleden`;
  const dagen = Math.floor(uur / 24);
  return dagen === 1 ? 'gisteren' : `${dagen} dagen geleden`;
}

const naam = (email) => {
  const deel = String(email || '').split('@')[0];
  return deel ? deel.charAt(0).toUpperCase() + deel.slice(1) : 'Iemand';
};

export default function LogTab({ productie, items }) {
  const [log, setLog] = useState(null);
  useEffect(() => {
    let weg = false;
    lijstLog(productie.id).then((l) => { if (!weg) setLog(l); }).catch((e) => { meldFout(e, 'Log laden'); setLog([]); });
    return () => { weg = true; };
  }, [productie.id, items]);

  if (log === null) return null;
  if (log.length === 0) return <Leeg>Nog geen activiteit.</Leeg>;
  return (
    <Kaart>
      {log.map((a) => (
        <Rij key={a.id}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: 13.5, color: INKT }}><b>{naam(a.actor)}</b> {a.message}</Typography>
          </Box>
          <Typography sx={{ fontSize: 12, color: STIL, whiteSpace: 'nowrap' }} title={a.created_at}>{geleden(a.created_at)}</Typography>
        </Rij>
      ))}
    </Kaart>
  );
}
